import {translations} from 'presentation/translations-new';

const {
	beforeDateItems: {
		attendanceNetwork,
		advantagesClub,
		protocolsConsult,
		pinSS,
		permanenceLetter,
		portabilityLetter,
		helpCenter,
		ombudsman,
	},
} = translations['pt-br'].privateFlow.home.earlyAccess;

const BEFORE_DATE_ITEMS = [
	{
		title: attendanceNetwork.title,
		description: attendanceNetwork.description,
	},
	{
		title: advantagesClub.title,
		description: advantagesClub.description,
	},
	{
		title: protocolsConsult.title,
		description: protocolsConsult.description,
	},
	{
		title: pinSS.title,
		description: pinSS.description,
	},
	{
		title: permanenceLetter.title,
		description: permanenceLetter.description,
	},
	{
		title: portabilityLetter.title,
		description: portabilityLetter.description,
	},
	{
		title: helpCenter.title,
		description: helpCenter.description,
	},
	{
		title: ombudsman.title,
		description: ombudsman.description,
	},
];

export {BEFORE_DATE_ITEMS};
